// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/footer/contact-card/contact-card.component.scss
// module id = 110
// module chunks = 0